// extracted by mini-css-extract-plugin
module.exports = {"root":"ContainersTable_root__3WbS6","buttons":"ContainersTable_buttons__1s6K9","button":"ContainersTable_button__1FOym"};